import { Injectable } from '@angular/core';

@Injectable()
export class GlobalDateUtils {
  constructor() {}

  public normalizeDateFilters(filter: any): void {
    if (!filter) return;

    if (Array.isArray(filter)) {
      for (let i = 0; i < filter.length; i++) {
        const item = filter[i];

        if (Array.isArray(item)) {
          // Rekursiv weiter in verschachtelte Filtergruppen
          this.normalizeDateFilters(item);
        } else if (typeof item === 'string') {
          // Prüfen, ob es ein Datumsstring ist (z. B. "12.11.2025, 00:00:00")
          const parsedDate = this.parseDateString(item);
          if (parsedDate) {
            // ISO-Datum als "yyyy-MM-dd" setzen
            filter[i] = this.formatLocalDate(parsedDate);
          }
        } else if (item instanceof Date) {
          // Falls DevExtreme einen echten Date liefert
          filter[i] = this.formatLocalDate(item);
        }
      }
    }
  }

  // Hilfsfunktion: Datum aus String parsen
  private parseDateString(value: string): Date | null {
    // Entferne Leerzeichen und Kommas
    const cleaned = value.trim().replace(',', '');
    // Versuche Standard-Formate (z. B. 12.11.2025 oder 12.11.2025 00:00:00)
    const match = cleaned.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})/);
    if (match) {
      const [_, d, m, y] = match;
      const date = new Date(Number(y), Number(m) - 1, Number(d));
      if (!isNaN(date.getTime())) {
        return date;
      }
    }

    // Fallback: ISO- oder englisches Format direkt parsen
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  private formatLocalDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
}
